<template>
	<div class="main-content-container container-fluid px-4">
		<div>
			<div class="page-header row no-gutters py-4">
				<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
				  <span class="text-uppercase page-subtitle">Servicio</span>
				  <h3 class="page-title">Agregar</h3>
			  </div>
		   </div>
			<div class="row">
	      <div class="col-12 col-lg-9">
	        <div class="card card-small mb-3">
	          <div class="card-body">
	            <div class="form-group">
	            	<select-solution
									@item-selected="setSolution"
	            	/>
	            </div>
	            <div class="form-group">
	            	<input type="text" class="form-control" :class="error.name.status" placeholder="Nombre" v-model="form.name">
	            	<div class="invalid-feedback">
	            		{{ error.name.message[0] }}
	            	</div>
	            </div>
	            <div class="form-group">
	            	<input type="text" class="form-control" placeholder="SLUG o URL amigable" v-model="slug" readonly/>
	            </div>
	            <div class="form-group">
	            	<drag-and-drop
									message="Presiona o arrastra y suelta un archivo"
									@file="setFile"
									@base64="setBase64"
	            	/>
	            </div>
	            <div class="alert alert-primary" role="alert" v-if="error.icon.message">
							  {{ error.icon.message[0] }}
							</div>
	            <div class="form-group">
	            	<textarea rows="4" class="form-control" :class="error.description.status" placeholder="Descripción" v-model="form.description"></textarea>
	            	<div class="invalid-feedback">
	            		{{ error.description.message[0] }}
	            	</div>
	            </div>
	          </div>
	          <div class="card-footer border-top">
	          	<button type="submit" class="btn btn-primary" @click.prevent="addSolution" v-if="isLoading==false">
	          		Agregar
	          	</button>
              <div class="text-left" v-if="isLoading==true">
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
	          </div>
	        </div>
	      </div>
        <div class="d-none d-md-inline-block col-lg-3 col-md-12">
          <div class='card card-small mb-3'>
            <div class="card-header border-bottom">
              <h6 class="m-0">Vista previa</h6>
            </div>
            <div class='card-body p-2 d-flex justify-content-center'>
              <i class="fas fa-images display-3 mt-4 mb-4 text-light" v-if="!form.icon"></i>
  						<img id="preview" :src="icon.src"/>
            </div>
            <div class="card-footer">
            	<button class="btn btn-secondary" v-if="form.icon" @click.prevent="deleteIcon">
               <i class="fas fa-trash"></i> 
              </button>
            </div>
          </div>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
	import DragAndDrop from '@/components/general/DragAndDrop';
	import SelectSolution from '@/components/dashboard/services/SelectSolution.vue';
	export default {
		data() {
			return {
				isLoading: false,
				form: {
					solution: '',
					name: '',
					icon: '',
					description: ''
				},
				icon: {
					src: ''
				},
				error: {
					name: {
						status: '',
						message: ''
					},
					icon: {
						status: '',
						message: ''
					},
					description: {
						status: '',
						message: ''
					}
				}
			}
		},

		computed: {
			slug: function() {
				return this.form.name.toLowerCase().split(' ').join('_')
			}
		},

		components: { SelectSolution, DragAndDrop },

		methods: {
			setSolution(data) {
				this.form.solution = data;
			},

			setFile(data) {
				this.form.icon = data;			
			},

			setBase64(data) {
				this.icon.src = data;
			},

			deleteIcon() {
				this.form.icon = '';
				this.icon.src = '';
			},

			async addSolution() {
				this.isLoading = true;
				this.cleanErrorMessages();
				const url = `${process.env.VUE_APP_ROOT_API}/service`;
				var formData = new FormData();
				formData.append('user_id', this.$store.state.auth.user.id);
				formData.append('solution_id', this.form.solution);
				formData.append('name', this.form.name);
				formData.append('slug', this.slug);
				formData.append('description', this.form.description);
				formData.append('icon', this.form.icon);
				const settings = {
					method: 'POST',
					body: formData
				};
				const response = await fetch(url, settings);
				const responseData = await response.json();
				const errors = responseData['errors'];
				switch (response.status) {
					case 200:
						this.isLoading = false;
						this.successMessage();
						break;
					case 422:
						this.isLoading = false;
						if(errors.name) {
							this.error.name.status = 'is-invalid';
							this.error.name.message = errors.name;
						}
						if(errors.icon) {
							this.error.icon.status = 'is-invalid';
							this.error.icon.message = errors.icon;
						}
						if(errors.description) {
							this.error.description.status = 'is-invalid';
							this.error.description.message = errors.description;
						}
						break;
				}
			},

			successMessage() {
		        this.$toasted.show("<i class='fas fa-square'></i> ¡Servicio agregado!", { 
		           theme: "toasted-primary", 
		           position: "top-right", 
		           duration : 2000
		        });
		        window.scrollTo(0, 0);
		        this.cleanInputs();
			},

			cleanInputs() {
				this.form.name = '';
				this.form.slug = '';
				this.form.description = '';
				this.form.icon = '';
				this.icon.src = '';
			},

			cleanErrorMessages() {
				this.error.name.status = '';
				this.error.name.message = '';

				this.error.icon.status = '';
				this.error.icon.message = '';

				this.error.description.status = '';
				this.error.description.message = '';
			}
		}
	}
</script>